import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { create, update } from "../../../constants/apiRoutes";

const RecipientForm = ({ editData, fetchRecipients }) => {
  const [recipientForm, setRecipientForm] = useState({
    recipientName: "",
    recipientEmail: "",
  });
  const [error, setError] = useState("");
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    editData &&
      setRecipientForm({
        recipientName: editData.name,
        recipientEmail: editData.email,
      });
    editData ? setIsEditing(true) : setIsEditing(false);
  }, [editData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setRecipientForm({ ...recipientForm, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const handleUpdateReceipent = async () => {
      try {
        let postData = {
          name: recipientForm.recipientName,
          email: recipientForm.recipientEmail,
        };

         await update(
          `Account/recipients/${editData.id}`,
          postData
        );
        fetchRecipients();
        resetForm();
        setError("");

        Swal.fire({
          icon: "success",
          title: "Recipient Updated Successfully",
          showConfirmButton: true,
          timer: 2500,
        });
      } catch (error) {
        console.error("Failed to update data:", error);
      }
    };

    const handleSubmitReceipent = async () => {
      try {
        let postData = {
          name: recipientForm.recipientName,
          email: recipientForm.recipientEmail,
        };
         await create(`Account/recipients`, postData);
        fetchRecipients();
        resetForm();
        setError("");
        Swal.fire({
          icon: "success",
          title: "Recipient added successfully",
          showConfirmButton: false,
          timer: 2500,
        });
      } catch (error) {
        console.error("Error adding recipient", error);
        setError("Failed to add recipient");
      }
    };

    if (editData) {
      return handleUpdateReceipent();
    } else {
      return handleSubmitReceipent();
    }
  };

  const resetForm = () => {
    setIsEditing(false);
    setRecipientForm({
      recipientName: "",
      recipientEmail: "",
    });
  };

  return (
    <div>
      <h2 className="text-sm font-bold text-gray-700 w-fit mb-4 p-2 rounded-lg">
        {isEditing ? "Update Recipient" : "Add Recipient"}
      </h2>
      <form
        onSubmit={handleSubmit}
        className="text-xs p-4 rounded-xl border-2 border-gray-200"
      >
        <div className="mb-12 flex flex-row gap-4 w-full">
          <label className="input border-none outline-none flex items-center h-9 gap-4 w-1/2 bg-gray-200">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 16 16"
              fill="currentColor"
              className="h-4 w-4 opacity-60"
            >
              <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM12.735 14c.618 0 1.093-.561.872-1.139a6.002 6.002 0 0 0-11.215 0c-.22.578.254 1.139.872 1.139h9.47Z" />
            </svg>
            <input
              type="text"
              name="recipientName"
              value={recipientForm.recipientName}
              onChange={handleChange}
              required
              className="grow"
              placeholder="Name"
            />
          </label>

          <label className="input bg-gray-200 flex h-9 items-center gap-4 w-1/2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 16 16"
              fill="currentColor"
              className="h-4 w-4 opacity-60"
            >
              <path d="M2.5 3A1.5 1.5 0 0 0 1 4.5v.793c.026.009.051.02.076.032L7.674 8.51c.206.1.446.1.652 0l6.598-3.185A.755.755 0 0 1 15 5.293V4.5A1.5 1.5 0 0 0 13.5 3h-11Z" />
              <path d="M15 6.954 8.978 9.86a2.25 2.25 0 0 1-1.956 0L1 6.954V11.5A1.5 1.5 0 0 0 2.5 13h11a1.5 1.5 0 0 0 1.5-1.5V6.954Z" />
            </svg>
            <input
              type="email"
              name="recipientEmail"
              value={recipientForm.recipientEmail}
              onChange={handleChange}
              required
              className="grow"
              placeholder="Email"
            />
          </label>
        </div>
        <div className="flex w-full gap-2 justify-end">
          <button
            type="submit"
            className="text-xs bg-yellow-700 text-white w-24 h-9 rounded-lg"
          >
            {isEditing ? "Update" : "Add"}
          </button>
          <button
            onClick={() => resetForm()}
            type="reset"
            className="text-xs bg-black text-white w-24 h-9 rounded-lg"
          >
            Cancel
          </button>
        </div>
        {error && <div className="text-red-500 mt-2">{error}</div>}
      </form>
    </div>
  );
};

export default RecipientForm;
